/* eslint-disable no-script-url */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2)
  },
  pushButton: {
    marginRight: theme.spacing(2)
  }
}))

const CenteredSubmitButton: React.FC<{
  submittable: boolean
  resettable?: boolean
  submitHandler: () => void
  resetHandler?: () => void
  submitText?: string
  resetText?: string
  size?: 'small' | 'medium' | 'large'
}> = ({
  submittable,
  resettable,
  submitHandler,
  resetHandler,
  submitText = '登録',
  resetText = 'リセット',
  size = 'medium'
}) => {
  const classes = useStyles({})

  return (
    <React.Fragment>
      <div className={classes.buttonContainer}>
        {resettable && (
          <Button
            className={classes.pushButton}
            variant="contained"
            color="primary"
            onClick={resetHandler}
            size={size}
          >
            {resetText}
          </Button>
        )}
        <Button
          type="submit"
          disabled={!submittable}
          className={classes.pushButton}
          variant="contained"
          color="primary"
          onClick={submitHandler}
          size={size}
        >
          {submitText}
        </Button>
      </div>
    </React.Fragment>
  )
}

export default CenteredSubmitButton
